function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRestaurantMenu = function SvgRestaurantMenu(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: props.fill,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M8.062 3.563v16.875m2.25-16.875v5.062a2.257 2.257 0 0 1-2.25 2.25 2.257 2.257 0 0 1-2.25-2.25V3.563m9 11.25h2.25a1.083 1.083 0 0 0 1.125-1.126c-.121-3.23-.252-6.615-2.335-9.867a.567.567 0 0 0-1.041.307v16.31"
  }));
};
export default SvgRestaurantMenu;